"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackNavigationClicked = trackNavigationClicked;
exports.trackMinimalLogoClick = trackMinimalLogoClick;

var _trackingHelper = require("../trackingHelper");

/* eslint-disable camelcase */

/**
 * Calls the segment "Navigation Clicked" event
 */
function trackNavigationClicked(eventData) {
  (0, _trackingHelper.trackEvent)('Navigation Clicked', eventData);
}
/**
 * Calls the segment "Navigation Clicked" event
 * Specifically for use on the Logo and a minimal navigation.
 *
 *  @function trackMinimalLogoClick
 *  @returns {void}
 */


function trackMinimalLogoClick() {
  var eventData = {
    menu_item: 'ZOLA',
    section: 'MINIMAL',
    node_level_1: 'ZOLA',
    row_position: 1,
    column_position: 1
  };
  trackNavigationClicked(eventData);
}